// extracted by css-extract-rspack-plugin
export default {"xSplit":"TimelineSection_xSplit__sjZJ7","labelInput":"TimelineSection_labelInput__4eBRx"};